import './scss/xl-tile-lite.scss';
import './scss/xl-tile-lite-desktop.scss';

import XLTileVimeoPlayer from /* webpackChunkName: "vimeoPlayer" */ './vimeo_video/index.js';
import XLTileYoutubePlayer from /* webpackChunkName: "youtubePlayer" */ './youtube_video/index.js';
import XLTileBgYoutubePlayer from /* webpackChunkName: "youtubeBgPlayer" */ './bg_yt_video/index.js';

export default class XLTileLite {
    constructor(el) {
        if (el.querySelector('.xl-tile-lite-vimeo-player')) {
            this.vimeo = new XLTileVimeoPlayer(el);
        }

        if (el.querySelector('.xl-tile-lite-youtube-player') && el.querySelector('.video-trigger')) {
            this.youtube = new XLTileYoutubePlayer(el);
        }

        if (el.querySelector('.xl-tile-lite-bg-yt-video')) {
            this.youtubeBg = new XLTileBgYoutubePlayer(el);
        }
    }
}
